import { Component } from 'react';
import { Link as LinkIcon, RefreshCw, Home, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-frost-white flex items-center justify-center p-4">
          <div className="max-w-md w-full text-center">
            <div className="inline-flex items-center space-x-3 mb-8">
              <div className="w-10 h-10 bg-dark-slate rounded-xl flex items-center justify-center transform rotate-[15deg]">
                <LinkIcon className="w-6 h-6 text-mint-fresh" />
              </div>
              <span className="font-heading font-bold text-2xl text-dark-slate">GradLink</span>
            </div>

            <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-ambient">
              <div className="w-16 h-16 bg-red-50 rounded-2xl flex items-center justify-center mx-auto mb-5">
                <AlertTriangle className="w-8 h-8 text-red-500" />
              </div>
              <h1 className="font-heading font-bold text-2xl text-dark-slate mb-2">
                Something went wrong
              </h1>
              <p className="text-slate-gray mb-6">
                An unexpected error occurred. This has been logged and we'll look into it.
              </p>

              {process.env.NODE_ENV === 'development' && this.state.error && (
                <div className="bg-red-50 rounded-xl p-3 mb-6 text-left">
                  <p className="text-red-700 text-xs font-mono break-all">
                    {this.state.error.toString()}
                  </p>
                </div>
              )}

              <div className="flex gap-3 justify-center">
                <Button
                  onClick={this.handleReset}
                  className="bg-dark-slate text-white rounded-full"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Try Again
                </Button>
                <Button
                  variant="outline"
                  className="rounded-full"
                  onClick={() => { this.handleReset(); window.location.href = '/feed'; }}
                >
                  <Home className="w-4 h-4 mr-2" />
                  Go Home
                </Button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
